const Shimmer =()=>{


return(

    <div>
        <h1> Im Shimmer UI</h1>
    </div>
)

}

export default Shimmer;